import { Avatar, Modal, Paper, Stack } from '@mui/material';
import { NextPrevButton } from 'Components/NextPrevButton';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { ExitDoor, PurpleClose } from 'Images';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';
import { TextNotification } from './TextNotification';
import { useMsal } from '@azure/msal-react';

interface ILogoutWarningModal {
  isWarning: boolean;
  closeModal: Function;
}

export const LogoutWarningAndNotificationModal = ({
  isWarning,
  closeModal,
}: ILogoutWarningModal) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.General
  ).activityGuard;
  const isDesktop = useIsDesktop();

  const { instance } = useMsal();

  const loginHandler = async () => {
    closeModal();
    await instance.loginRedirect();
  };

  const logoutHandler = async () => {
    sessionStorage.clear();
    closeModal();
    await instance.logoutRedirect();
  };

  return (
    <Modal
      open
      sx={{
        zIndex: 2000,
      }}
      BackdropProps={{
        sx: {
          backdropFilter: 'blur(5px)',
        },
      }}
    >
      <Paper
        sx={{
          width: '100%',
          maxWidth: isDesktop ? '770px' : '355px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
          padding: '16px 16px 48px 16px',
          bgcolor: '#E7EDFF',
          borderRadius: '16px',
          border: 'none',
          boxShadow: '-2px -2px 10px 0px #081E540A',
          ':focus': {
            outline: 'none',
          },
        }}
      >
        <Avatar
          alt={dictionary.closeModal}
          src={PurpleClose}
          sx={{ ml: 'auto', cursor: 'pointer' }}
          tabIndex={0}
          onClick={() => (isWarning ? closeModal() : loginHandler())}
          onKeyDown={onEnterOrEscapeKeyDown}
          aria-live='assertive'
        />
        <Stack alignItems='center' gap='32px'>
          <TextNotification isWarning={isWarning} />
          <Stack alignItems='center' gap='24px'>
            <NextPrevButton
              text={
                isWarning ? dictionary.continueActivity : dictionary.connect
              }
              callback={() => (isWarning ? closeModal() : loginHandler())}
              isBlue
              isNext
            />
            <NextPrevButton
              text={isWarning ? dictionary.logout : dictionary.toHomePage}
              hideArrowIcon
              icon={
                isWarning
                  ? {
                      src: ExitDoor,
                      sx: { width: '22px', height: '22px' },
                    }
                  : undefined
              }
              callback={() =>
                isWarning
                  ? logoutHandler()
                  : (window.location.href =
                      process.env.REACT_APP_MARKETING_SITE_URL || '')
              }
            />
          </Stack>
        </Stack>
      </Paper>
    </Modal>
  );
};
